/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { ChevronDownIcon } from '@coursera/cds-icons';

const styles = {
  icon: css`
    height: 12px;
    width: 12px;
  `,
};

type Props = {
  className?: string;
};

const DropdownIcon = ({ className }: Props) => {
  return <ChevronDownIcon css={styles.icon} className={className} />;
};

export default React.memo(DropdownIcon);
